import React, { useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory, useLocation } from "react-router-dom";

import { applyAuthToken } from "../../utils/authToken";

const DEFAULT_REDIRECT_PATH = "/pilot/purchase";

const getSafeRedirectPath = (redirectPath) => {
  if (!redirectPath || !redirectPath.startsWith("/pilot")) {
    return DEFAULT_REDIRECT_PATH;
  }

  return redirectPath;
};

const TokenLogin = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const redirectPath = getSafeRedirectPath(params.get("redirect"));

    if (!token) {
      history.replace("/pilot/login");
      return;
    }

    const { ok } = applyAuthToken(token);

    // Invalid or expired token: applyAuthToken has already wiped cookie,
    // axios header and profile — land the user on a clean login page.
    if (!ok) {
      history.replace("/pilot/login", { from: redirectPath });
      return;
    }

    history.replace(redirectPath);
  }, [history, location.search]);

  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        height: "100vh",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default TokenLogin;
